import { supabase, adminSupabase } from '../services/supabaseService';

// Function to check both standard and admin Supabase connections
export async function checkSupabaseConnection() {
    console.group('Supabase Connection Check');

    try {
        console.log('Checking regular Supabase connection...');
        // Fix the count(*) syntax issue by using a different query
        const { data: regularData, error: regularError } = await supabase
            .from('new_tokens')
            .select('id', { count: 'exact', head: true });

        if (regularError) {
            console.error('Regular connection error:', regularError.message);
        } else {
            console.log('Regular connection successful!', regularData);
        }
    } catch (error) {
        console.error('Regular connection exception:', error);
    }

    try {
        console.log('Checking admin Supabase connection...');
        // Fix the count(*) syntax issue by using a different query
        const { data: adminData, error: adminError } = await adminSupabase
            .from('users')
            .select('id', { count: 'exact', head: true });

        if (adminError) {
            console.error('Admin connection error:', adminError.message);
        } else {
            console.log('Admin connection successful!', adminData);
        }
    } catch (error) {
        console.error('Admin connection exception:', error);
    }

    console.groupEnd();
}

// Remove auto-run to prevent connection attempts before wallet connection
// Instead, export the function to be called explicitly when needed

export default checkSupabaseConnection;
